import { EventEmitter, Injectable, Output } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CNHealthAgent } from '../models/cnhealthagent';
import { CNPatient } from '../models/cnpatient';
import { CNReport } from '../models/cnreport';
import { SNItem } from '../models/snitem';
import { SNItemFactory } from '../models/snitemfactory';
import { SNItemTableControl, SNItemTableService, SNItemTableServiceCapability } from '../snitem-table/snitem-table-interface';
import { BecareService } from './becare.service';
import { PatientService } from './patient.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService implements SNItemTableService {

  private static instance: ReportService = null;

  private currentpatient: CNPatient;
  private reports: CNReport[];
  public dataStart = 0;
  public dataLimit = 10;
  public dataLength = 0;

  public data = new BehaviorSubject<CNReport[]>([]);
  @Output() clear = new EventEmitter<boolean>();

  constructor(private becare: BecareService, private patient: PatientService) {
    this.patient.patientSelectedEvent.subscribe(patientselected => {
      this.currentpatient = patientselected;
      this.dataStart = 0;
      this.dataLength = 0;
      this.data.next([]);
      this.clear.emit(true);
      this.load();
    });
  }

  public static getInstance(): ReportService {
    return ReportService.instance;
  }

  public load() {
      // Query patient reports
      // tslint:disable-next-line:max-line-length
      this.becare.call('/fr/patient/' + this.currentpatient.id + '/report?start=' + this.dataStart + '&limit=' + this.dataLimit).subscribe(result => {
        if (result.success === true && result.reports !== undefined) {
          const factory = new SNItemFactory();
          this.reports = factory.itemsFromJson(result.reports);
          this.dataLength = result.total;
          this.data.next(this.reports);
        }
      });
  }

  public toggleValidation(report: CNReport): Observable<CNReport> {
    return new Observable(observer => {
      const factory = new SNItemFactory();
      if (report.validated) {
        // tslint:disable-next-line:max-line-length
        const callSub = this.becare.call('/fr/patient/' + this.currentpatient.id + '/report/' + report.id + '/unvalidate', [], '', 'put').subscribe(result => {
          if (typeof(result.success) !== 'undefined' && result.success === true) {
            const unvalidatedReport: CNReport = factory.itemFromJson(result.report);
            observer.next(unvalidatedReport);
          }
          callSub.unsubscribe();
        });
      } else {
        // tslint:disable-next-line:max-line-length
        const callSub = this.becare.call('/fr/patient/' + this.currentpatient.id + '/report/' + report.id + '/validate', [], '', 'put').subscribe(result => {
          if (typeof(result.success) !== 'undefined' && result.success === true) {
            const validatedReport: CNReport = factory.itemFromJson(result.report);
            observer.next(validatedReport);
          }
          callSub.unsubscribe();
        });
      }
    });
  }

  public userReport(user: CNHealthAgent, validated = false): Observable<CNReport[]> {
    return new Observable(observer => {
      const factory = new SNItemFactory();
      // tslint:disable-next-line:max-line-length
      const callSub = this.becare.call('/fr/user/' + user.id + '/report/validated?validated=' + (validated ? 'true' : 'false')).subscribe(result => {
        if (typeof(result.success) !== 'undefined' && result.success === true) {
          observer.next(factory.itemsFromJson(result.reports));
        }
        callSub.unsubscribe();
      });
    });
  }

  public emailReports(user: CNHealthAgent, reports: CNReport[]) {
    
  }

  addItem(item: CNReport) { }

  snRegisterControl(control: SNItemTableControl) {
    console.log('register control');
  }

  snCapabilities(): SNItemTableServiceCapability[] {
    return [SNItemTableServiceCapability.search];
  }

  get fields() {
    return Object.keys(this.reports[0].properties);
  }

  store() { }

  send() { }

}
